import { OrderPlacedSidePanel } from './OrderPlacedSidePanel';
import { connectOrderPlacedSidePanel } from './OrderPlacedSidePanel.connect';

export const ConnectedOrderPlacedSidePanel = connectOrderPlacedSidePanel(OrderPlacedSidePanel);
